export default __webpack_public_path__ + "static/aayushi4-699501fa610cec6e258b2ca27a7794b7.jpg";